import { capitalize, startCase, flow } from 'lodash';

export const titleCase = flow([capitalize, startCase]);
